import { render } from "./MultipleConfig.vue?vue&type=template&id=6f2351fc&scoped=true"
import script from "./MultipleConfig.vue?vue&type=script&lang=js"
export * from "./MultipleConfig.vue?vue&type=script&lang=js"

import "./MultipleConfig.vue?vue&type=style&index=0&id=6f2351fc&scoped=true&lang=scss"

import exportComponent from "/data/soft/jenkins/jobs/release-ms-front/workspace/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6f2351fc"]])

export default __exports__